module.exports = __webpack_public_path__ + "img/hero-line.42b37008.png";